module.exports = __webpack_public_path__ + "static/media/location-green.e9cdf3ec.svg";